import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import { DETAILS_CONTENT_KEYS, IPlanContent } from '../typings/planContent.types';
import { PlanKeyDetailsModal } from './common/PlanKeyDetailsModal';
import {
  CONTENT_SEPARATOR,
  PLAN_DETAILS_PLAN_PERIOD,
  PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
} from '../typings';
import {
  businessDualKeyDetailsAddons,
  defaultBusinessGasDetailsAddons,
} from './common/planDefaults';
import { defaultEstimatesDialog } from './common/planDefaults';

export const originBusinessBasicPlanContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Business Basic']),
  content: {
    rateChangePrepositionText: {
      VIC: {
        defaultFuel:
          "Our electricity rates will change on 1 August. You'll see your new charges on your next bill after that time.",
        gas: '',
      },
      defaultState: {
        defaultFuel: '',
      },
    },
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on an ongoing contract',
      },
    },
    keyFeatures: {
      defaultState: {
        defaultFuel: ['No end date', 'No lock in contract or exit fees'],
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: [
          {
            contentKey: DETAILS_CONTENT_KEYS.Rates,
            contentValue: 'Variable',
            modalContent: PlanKeyDetailsModal,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
            contentDescription: 'Variable rates',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.ExitFees,
            contentValue: 'No',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
            contentDescription: 'No exit fees. Leave anytime.',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
            contentValue:
              PLAN_DETAILS_PLAN_PERIOD.Ongoing +
              CONTENT_SEPARATOR +
              PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
            contentDescription: 'Ongoing contract',
          },
        ],
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: businessDualKeyDetailsAddons,
        gas: defaultBusinessGasDetailsAddons,
        electricity: [],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'grey',
              odsCore: 'neutral',
            },
            promobox: {
              styleGuide: 'lightOrange',
              odsCore: 'caution',
            },
            bannerText: {
              styleGuide: 'grey56',
              odsCore: 'neutralDark',
            },
          },
          imageUrl:
            'https://res.cloudinary.com/originenergy/image/upload/v1728625583/spot-illustrations/spot_service.svg',
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-basic.svg',
            gas: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-basic_gas_2.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-basic.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: 'Choose energy with variable rates',
      },
    },
    estimatesDialog: defaultEstimatesDialog({ customerType: 'business' }),
  },
};
